<template>
  <v-btn
    v-if="this.params.value"
    icon
    :href="this.params.value"
    target="_blank"
  >
    <v-icon size="12" color="primary">perm_media</v-icon>
  </v-btn>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
  name: "IndexMediaVideo",
  computed: {
    data() {
      return {
        type: "video",
        url: this.params.value,
      }
    },
  },
})
</script>

<style lang="scss" scoped />
